'use client';

/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
export const useStyles = theme => ({
  containerStyle: {
    maxWidth: { xs: 600, md: 'lg' },
  },
  scrollBox: { display: 'flex', justifyContent: 'center', cursor: 'pointer' },
  scrollToTop: {
    color: theme.palette.default.textColor3,
  },
  secondaryNav: {
    p: '0.75rem',
    [theme.breakpoints.down('md')]: {
      p: 2,
    },
  },
  navGrid: { display: 'flex' },
  containerGrid: {
    pt: 2,
  },
  container: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    flexWrap: { xs: 'no-wrap', md: 'wrap' },
    justifyContent: 'center',
    maxWidth: { xs: '100%', sm: '100%', md: '100%' },
  },
  link: {
    width: 'fit-content',
    color: theme.palette.default.textColor3,
    p: { xs: 1.5, md: 1.5 },
    textAlign: { xs: 'left' },
  },
  navTitle: {
    color: theme.palette.default.textColor3,
    cursor: 'pointer',
    pb: 4,
    [theme.breakpoints.down('md')]: {
      p: 0,
    },
  },
  mobileNav: {
    [theme.breakpoints.down('md')]: {
      p: 1,
    },
  },
  disclaimerStyle: {
    maxWidth: { xs: '100vw', sm: '60vw' },
    mr: 'auto',
    ml: 'auto',
    color: theme.palette.default.textColor3,
    '& #ot-sdk-btn.ot-sdk-show-settings': {
      fontFamily: 'eirsans-light',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      backgroundColor: theme.palette.default.backgroundColor2,
      borderColor: theme.palette.default.buttonColor,
      fontWeight: '700',
      borderWidth: '2px',
      borderStyle: 'solid',
      color: theme.palette.default.buttonColor,
      marginBottom: '1rem',
      marginTop: '-1.5rem',
      borderRadius: '5px',
      p: '0.75rem 2rem',
      cursor: 'pointer',
      ':hover': {
        backgroundColor: theme.palette.default.buttonColor,
        color: theme.palette.default.textColor,
      },
    },
  },
});
